import axios from "axios";
// console.log(`AXIOS CONFIGURACION API: ${process.env.VUE_APP_SERVER_API} `)

export const API_URL = process.env.VUE_APP_SERVER_API || "";
export const API_MANAGER = process.env.VUE_APP_API_MANAGER || "https://apimanager.clicken1.com.pe/";
export const IS_DEV = process.env.VUE_APP_API_IS_DEV || false;
export const BUCKET_ORIGIN_SPACE = process.env.VUE_APP_BUCKET_ORIGIN_SPACE || "VALOR_DEFAULT";

// export const VideoIcon = `${BUCKET_ORIGIN_SPACE}/recurso/public/video-play.df8d4588.png`
export const VideoIcon = '/recurso/public/video-play.df8d4588.png'
export const AudioIcon='/recurso/public/volume.png'
export const PDFIcon='/recurso/public/pdf-file.png'
export const WordIcon='/recurso/public/microsoft-word-file.png'
export const XLSIcon='/recurso/public/xls-file.png'
export const XLSXIcon='/recurso/public/xlsx-file.png'



const instance = axios.create({
  baseURL: API_URL,
  headers: {  
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${sessionStorage.token}`
 }
});

// Authenticated exist in sessionStorage
export const isAuthenticated = async () => {
  return sessionStorage.getItem("token") == undefined ? false : sessionStorage.getItem("token");
};

// if token expidered
export default instance;
